export type FacetChangeType = 'filter' | 'select' | 'expand';
export class FacetChangeEvent {
	constructor(public type: FacetChangeType) {}
}
